import { Injectable } from '@angular/core';
import { map, catchError } from 'rxjs/operators';
import { throwError } from 'rxjs';



import { HttpClient, HttpResponse, HttpHeaders } from '@angular/common/http';
import { HttpClientService, UtilityService, AdobeAnalyticsService } from 'lib/ng2-sapmp/src/providers';
import { ReviewOrderProductModel } from './review-order-product.model';
import { ANALYTICS_CONSTANTS } from 'config';
declare var ENV_PORTAL;
@Injectable()
export class ReviewOrderProductService {
    dataLayer = {};
    constructor(
        private http: HttpClient,
        private httpClientService: HttpClientService,
        private utilityService: UtilityService,
        private adobeAnalyticsService: AdobeAnalyticsService
    ) { }


    processOrder(model: ReviewOrderProductModel) {

        const requestBody = this.buildRequest(model);

        if (model.type === 'RemoveAll') {
            return this.httpClientService.authorizedRequest(
                this.utilityService.getEnvConfig().cartOrderUrl, 'delete',
                requestBody)
                .pipe(
       map((resp: HttpResponse<any>) => {
                    this.httpClientService.updateAuthorizationHeaders(resp);
                    return resp.body;
                })
                ,catchError( this.handleError ));
        } else if (model.type === 'Increase' || model.type === 'Decrease') {
            return this.httpClientService.authorizedPut(
                this.utilityService.getEnvConfig().cartOrderUrl,
                requestBody)
                .pipe(
       map((resp: HttpResponse<any>) => {
                    this.httpClientService.updateAuthorizationHeaders(resp);
                    return resp.body;
                })
                ,catchError( this.handleError ));
        } else if (model.type === 'DiffCTN') {
            return this.httpClientService.authorizedPost(
                this.utilityService.getEnvConfig().cartOrderUrl,
                requestBody)
                .pipe(
       map((resp: HttpResponse<any>) => {
                    this.httpClientService.updateAuthorizationHeaders(resp);
                    return resp.body;
                })
                ,catchError( this.handleError ));
        } else if (model.type === 'changeProduct') {
            return this.httpClientService.authorizedPost(
                this.utilityService.getEnvConfig().changeCartOrderUrl,
                requestBody)
                .pipe(
       map((resp: HttpResponse<any>) => {
                    this.httpClientService.updateAuthorizationHeaders(resp);
                    return resp.body;
                })
                ,catchError( this.handleError ));
        }

    }

    buildRequest(requestModel: ReviewOrderProductModel) {
        let requestBody: any;
        const model = Object.assign(new ReviewOrderProductModel(), requestModel);
        model.ctn = model.ctn.replace(/\./g, '');
        requestBody = {
            paymentDetails: {
                btmPaymentMethod: {
                    fan: model.fan,
                    billingCTN: model.ctn
                }
            },
            subscriptionId: model.subscriptionId
        };

        if (model.type === 'Increase' || model.type === 'Decrease') {
            requestBody.modificationType = model.type;
            requestBody.currentQuantity = model.initialLicense;
        }

        if (model.type === 'changeProduct') {
            requestBody.lineItems = model.lineItems;
            requestBody.orderServiceType = 'changeProduct';
            requestBody.paymentDetails.btmPaymentMethod.billingCTN = model.ctn;

        } else if (model.type === 'DiffCTN') {
            requestBody.paymentDetails.btmPaymentMethod.billingCTN = model.ctn;
            requestBody.quantity = model.modifiedLicense;
            requestBody.dcmCode = model.serviceOfferCode;
        } else {
            requestBody.quantity = model.modifiedLicense;
            requestBody.dcmCode = model.serviceOfferCode;
        }

        return requestBody;

    }

    // modify lisence adobe analytics call
    // tslint:disable-next-line:max-line-length
    createModifyLicenseProperties(type: string, totalQty: number, dcmCode: string, priceMonthly: number, estimatedDiscount: number, status: string, event: string,
        orderNo?: string, errorCode?: string, errorText?: string) {
        this.dataLayer = {};
        if (type === 'Increase') {
            this.dataLayer[ANALYTICS_CONSTANTS.EVENT_EVENT_CODE] = ANALYTICS_CONSTANTS.EVENT_CODE_INCREASE_LICENSE;
            this.dataLayer[ANALYTICS_CONSTANTS.EVENT_FLOW_CODE] = ANALYTICS_CONSTANTS.FLOW_CODE_LICENSE_MANAGEMNET_INCREASE;
        } else if (type === 'Decrease') {
            this.dataLayer[ANALYTICS_CONSTANTS.EVENT_EVENT_CODE] = ANALYTICS_CONSTANTS.EVENT_CODE_DECREASE_LICENSE;
            this.dataLayer[ANALYTICS_CONSTANTS.EVENT_FLOW_CODE] = ANALYTICS_CONSTANTS.FLOW_CODE_LICENSE_MANAGEMNET_DECREASE;
        } else {
            this.dataLayer[ANALYTICS_CONSTANTS.EVENT_EVENT_CODE] = ANALYTICS_CONSTANTS.EVENT_CODE_REMOVEALL_LICENSE;
            this.dataLayer[ANALYTICS_CONSTANTS.EVENT_FLOW_CODE] = 'BC~LicenseManagement~Remove';
        }
        if (orderNo) {
            this.dataLayer[ANALYTICS_CONSTANTS.EVENT_ORDER_ID] = orderNo;
        }
        if (status === 'SUCCESS') {
            this.dataLayer[ANALYTICS_CONSTANTS.EVENT_ITEMS] = [];
            if (type === 'Increase' || type === 'Decrease') {
                const item = { itemQty: 0, itemSku: undefined, priceMonthly: undefined };
                item.itemQty = totalQty;
                item.itemSku = dcmCode;
                item.priceMonthly = priceMonthly.toFixed(2);
                if (estimatedDiscount > 0) {
                    item['discountAmount'] = estimatedDiscount.toFixed(2);
                }
                this.dataLayer[ANALYTICS_CONSTANTS.EVENT_ITEMS].push(item);
            } else {
                const item = { itemQty: 0, itemSku: undefined, priceMonthly: undefined };
                item.itemQty = totalQty;
                item.itemSku = dcmCode;
                item.priceMonthly = priceMonthly.toFixed(2);
                this.dataLayer[ANALYTICS_CONSTANTS.EVENT_ITEMS].push(item);
            }
            this.dataLayer[ANALYTICS_CONSTANTS.EVENT_SUCCESS_FLAG] = ANALYTICS_CONSTANTS.EVENTS_SUCCESSFLAG_1;
            this.dataLayer[ANALYTICS_CONSTANTS.EVENT_ERROR_TYPE] = ANALYTICS_CONSTANTS.EVENT_ERROR_SUCCESS_TYPE;
            this.dataLayer[ANALYTICS_CONSTANTS.EVENT_STATUS_CODE] = ANALYTICS_CONSTANTS.EVENTS_SUCCESSFLAG_0;
        } else {
            this.dataLayer[ANALYTICS_CONSTANTS.EVENT_SUCCESS_FLAG] = ANALYTICS_CONSTANTS.EVENTS_SUCCESSFLAG_0;
            this.dataLayer[ANALYTICS_CONSTANTS.EVENT_ERROR_TYPE] = ANALYTICS_CONSTANTS.EVENT_ERROR_FAILURE_TYPE_FAILURE_SYSTEM;
            this.dataLayer[ANALYTICS_CONSTANTS.EVENT_STATUS_CODE] = errorCode;
            // this.dataLayer[ANALYTICS_CONSTANTS.EVENT_STATUS_MESSAGE] = errorText;
        }

        if (type === 'Increase') {
            this.adobeAnalyticsService.tag('event', this.dataLayer, ANALYTICS_CONSTANTS.EVENT_CODE_INCREASE_LICENSE, event);
        } else if (type === 'Decrease') {
            this.adobeAnalyticsService.tag('event', this.dataLayer, ANALYTICS_CONSTANTS.EVENT_CODE_DECREASE_LICENSE, event);
        } else {
            this.adobeAnalyticsService.tag('event', this.dataLayer, ANALYTICS_CONSTANTS.EVENT_CODE_REMOVEALL_LICENSE, event);
        }
    }

    handleError = (error) => {
        return throwError(error);
    }
    // tslint:disable-next-line:max-line-length
    createPageLoadProperties(url: string, fan, ctn, title: string, friendlyPageName: string, skuCode: string, pageType: string, key?: string) {
        this.dataLayer = {};
        if (key !== undefined && key === 'virtual') {
            this.dataLayer[ANALYTICS_CONSTANTS.GLOBAL_PAGE_LOCATION_URL] = ANALYTICS_CONSTANTS.ENVIRONMENT_URL + url;
        }
        this.dataLayer[ANALYTICS_CONSTANTS.GLOBAL_PAGE_FRIENDLY_PAGE_NAME] = friendlyPageName;
        if (pageType === 'Increase' || pageType === 'DiffCTN') {
            this.dataLayer[ANALYTICS_CONSTANTS.GLOBAL_PAGE_FLOW_CODE] = ANALYTICS_CONSTANTS.FLOW_CODE_LICENSE_MANAGEMNET_INCREASE;
        } else if (pageType === 'Decrease') {
            this.dataLayer[ANALYTICS_CONSTANTS.GLOBAL_PAGE_FLOW_CODE] = ANALYTICS_CONSTANTS.FLOW_CODE_LICENSE_MANAGEMNET_DECREASE;
        } else if (pageType === 'RemoveAll') {
            this.dataLayer[ANALYTICS_CONSTANTS.GLOBAL_PAGE_FLOW_CODE] = ANALYTICS_CONSTANTS.FLOW_CODE_LICENSE_MANAGEMNET_REMOVE;
        } else if (pageType === 'changeProduct') {
            this.dataLayer[ANALYTICS_CONSTANTS.GLOBAL_PAGE_FLOW_CODE] = ANALYTICS_CONSTANTS.FLOW_CODE_CHANGE_PRODUCT;
        } else {
            this.dataLayer[ANALYTICS_CONSTANTS.GLOBAL_PAGE_FLOW_CODE] = ANALYTICS_CONSTANTS.FLOW_CODE_CHECKOUT;
        }

        this.dataLayer[ANALYTICS_CONSTANTS.GLOBAL_PAGE_LANGUAGE] = 'EN';
        this.dataLayer[ANALYTICS_CONSTANTS.GLOBAL_USER_LOGIN_SOURCE] = 'shoplogin';
        this.dataLayer[ANALYTICS_CONSTANTS.GLOBAL_PAGE_PAGE_FUNCTION] = 'Service';
        this.dataLayer[ANALYTICS_CONSTANTS.GLOBAL_PAGE_ABS_CHECKOUT_STEP] = title;
        if (fan !== '') {
            this.dataLayer[ANALYTICS_CONSTANTS.GLOBAL_USER_FAN] = fan;
        }
        if (ctn !== '') {
            this.dataLayer[ANALYTICS_CONSTANTS.GLOBAL_USER_CTN] = ctn.replace(/\./g, '');
        }
        this.dataLayer[ANALYTICS_CONSTANTS.GLOBAL_PAGE_SKU] = skuCode;      
        this.adobeAnalyticsService.tag('page', this.dataLayer, 'Page_Load', 'pageLoad');
    }

    // to get tnc
    getServiceProdTnc() {
        return this.httpClientService.authorizedGet(this.utilityService.getEnvConfig().productTncUrl)
            .pipe(
       map((res: HttpResponse<any>) => {
                this.httpClientService.updateAuthorizationHeaders(res);
                return res.body;
            }
            )
            ,catchError( this.handleError ));
    }

}
